<template>

<div class="main list-view no-sub-header">

	<div class="filters" v-if="showFilters">

		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList()">Filter Dates</div>
		</div>

		<div class="divider"></div>

		<div v-if="orderId" class="button neutral" @click="backToList()"><i class="fa fa-arrow-circle-left"></i> Back To Cashier</div>
		<div v-else-if="filters.user_id" class="button neutral" @click="backToList()">Back To List</div>
		<div :class="['extra-menu-item', gettingExport ? 'disabled' : '']" @click="doExport()">Export CSV</div>
		<div :class="['extra-menu-item', printing ? 'disabled' : '']" @click="doPrint()">Print Report</div>

		<div v-if="reportFilters.length > 0">
			<label>This report is filtered to include only<br>these departments / categories...</label>
			<div v-for="(filter, index) in reportFilters"> &ndash; {{ filter }}</div>
		</div>

	</div>

	<div v-if="orderId" class="detail no-sub-header">
		<order-detail :orderDetail="orderDetail" :orderStatusCodes="orderStatusCodes" :packingSlip="showPackingSlip" :key="'packing-slip' + showPackingSlip" />
	</div>

	<div v-else-if="filters.user_id" class="detail no-sub-header">

		<div class="detail-sub-header">
			<div class="detail-title" v-html="detail.full_name"></div>
		</div>

		<div class="list">
		    <table class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list left">Order<br>Number</th>
						<th class="list left">Order<br>Date</th>
						<th class="list right">Sale<br>Payments</th>
						<th class="list right">Layaway<br>Payments</th>
						<th class="list right">Item<br>Price</th>
						<th class="list right">Item<br>Cost</th>
						<th class="list right">Cart<br>Discounts</th>
						<th class="list right">Sale<br>Profit</th>
						<th class="list right">Profit<br>Percent</th>
						<th class="list right">Gift<br>Cards</th>
					</tr>
				</thead>
				<tr v-for="item in detail.orders" class="clickable-list-item" @click="getOrder(item.order_id)">
					<td class="list left">{{ item.order_number }}</td>
					<td class="list left">{{ item.order_date }}</td>
					<td class="list right">{{ item.payments > 0 ? item.payments : '' }}</td>
					<td class="list right">{{ item.payments_layaway > 0 ? item.payments_layaway : '' }}</td>
					<td class="list right">{{ item.item_price > 0 ? item.item_price : '' }}</td>
					<td class="list right">{{ item.item_cost > 0 ? item.item_cost : '' }}</td>
					<td class="list right">{{ item.discounts > 0 ? item.discounts : '' }}</td>
					<td class="list right">{{ item.profit > 0 ? item.profit : '' }}</td>
					<td class="list right">{{ item.profit_percent > 0 ? item.profit_percent : '' }}</td>
					<td class="list right">{{ item.gift_cards > 0 ? item.gift_cards : '' }}</td>
				</tr>
				<tr v-if="detail.totals" class="list_row_totals">
					<td class="list left">Totals</td>
					<td class="list left"></td>
					<td class="list right">{{ detail.totals.payments > 0 ? detail.totals.payments : '' }}</td>
					<td class="list right">{{ detail.totals.payments_layaway > 0 ? detail.totals.payments_layaway : '' }}</td>
					<td class="list right">{{ detail.totals.item_price > 0 ? detail.totals.item_price : '' }}</td>
					<td class="list right">{{ detail.totals.item_cost > 0 ? detail.totals.item_cost : '' }}</td>
					<td class="list right">{{ detail.totals.discounts > 0 ? detail.totals.discounts : '' }}</td>
					<td class="list right">{{ detail.totals.profit > 0 ? detail.totals.profit : '' }}</td>
					<td class="list right">{{ detail.totals.profit_percent > 0 ? detail.totals.profit_percent : '' }}</td>
					<td class="list right">{{ detail.totals.gift_cards > 0 ? detail.totals.gift_cards : '' }}</td>
				</tr>
			</table>
		</div>

	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Cashier</th>
					<th class="list left">Sale<br>Payments</th>
					<th class="list left">Layaway<br>Payments</th>
					<th class="list right">Item<br>Price</th>
					<th class="list right">Item<br>Cost</th>
					<th class="list right">Cart<br>Discounts</th>
					<th class="list right">Sale<br>Profit</th>
					<th class="list right">Profit<br>Percent</th>
					<th class="list right">Gift<br>Cards</th>
				</tr>
			</thead>
			<tr v-for="item in list" :class="item.is_list_item ? 'clickable-list-item' : 'list_row_totals'" @click="getItem(item)">
				<td class="list left">{{ item.full_name }}</td>
				<td class="list left">{{ item.payments > 0 ? item.payments : '' }}</td>
				<td class="list left">{{ item.payments_layaway > 0 ? item.payments_layaway : '' }}</td>
				<td class="list right">{{ item.item_price > 0 ? item.item_price : '' }}</td>
				<td class="list right">{{ item.item_cost > 0 ? item.item_cost : '' }}</td>
				<td class="list right">{{ item.discounts > 0 ? item.discounts : '' }}</td>
				<td class="list right">{{ item.profit > 0 ? item.profit : '' }}</td>
				<td class="list right">{{ item.profit_percent > 0 ? item.profit_percent : '' }}</td>
				<td class="list right">{{ item.gift_cards > 0 ? item.gift_cards : '' }}</td>
			</tr>
		</table>

	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

	<help-popup :helpLink="{235:'Cashier Commission Report'}" :tours="false"></help-popup>

</div>

</template>

<script>
import OrderDetail from '@/components/OrderDetail.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'cashier-commission-report',
    components: {
        'order-detail': OrderDetail,
		'help-popup': HelpPopup
	},
	data() {
		return {
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			showFilters: true,
			filters: {},
            default_start_date: '',
            default_end_date: '',
			filterMessage: '',
			filterLoading: false,
			list: [],
			paging: {},
			showDetail: false,
			detail: {},
			orderId: '',
			orderDetail: {},
			orderStatusCodes: [],
			showPackingSlip: false,
			exportMessage: '',
			gettingExport: false,
			printing: false,
			reportFilters: []
		}
	},
	created() {
		this.clearFilters()
	},
	methods: {
		clearFilters() {
			this.filters = {
				start_date: '',
				end_date: '',
				user_id: '',
				do_export: false
			}
			this.default_start_date = new Date().toISOString().slice(0,10)
			this.default_end_date = new Date().toISOString().slice(0,10)
			this.filters.start_date = this.default_start_date
			this.filters.end_date = this.default_end_date
			this.getList()
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Generating report...'
			this.apiCall({ destination: 'get_list_cashier_commission', data: this.filters }).then(obj => {
				this.loading = false
				this.message = obj.message
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					if (this.filters.do_export) {
						this.filters.do_export = 0
						document.getElementById("download").src = obj.download_url
						this.gettingExport = false
						this.exportMessage = ''
					} else {
						this.list = obj.list
						this.reportFilters = obj.report_filters
					}
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getItem(item) {
			if (this.loading || !item.is_list_item) { return }
			this.loading = true
			this.message = 'Generating report...'
			this.filters.user_id = item.user_id
			this.apiCall({ destination: 'get_item_cashier_commission', data: this.filters }).then(obj => {
				this.loading = false
				this.message = obj.message
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					if (this.filters.do_export) {
						this.filters.do_export = 0
						document.getElementById("download").src = obj.download_url
						this.gettingExport = false
						this.exportMessage = ''
					} else {
						this.detail = obj.detail
					}
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getOrder(orderId) {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_order', data: { order_id: orderId } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.orderDetail.order = obj.order_detail
					this.orderDetail.billing = obj.order_billing_address
					this.orderDetail.shipping = obj.order_shipping_address
					this.orderDetail.items = obj.order_items
					this.orderDetail.discount = obj.order_discounts
					this.orderDetail.fees = obj.order_fees
					this.orderDetail.payments = obj.order_payments
					this.orderDetail.totals = obj.order_totals
					this.orderId = orderId
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			if (this.filters.user_id) {
				this.exportMessage = 'Generating CSV for ' + this.detail.orders.length + ' items...'
				this.filters.product_id = ''
				this.filters.do_export = true
				this.getItem(this.detail)
			} else {
				this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
				this.filters.product_id = ''
				this.filters.do_export = true
				this.getList(1)
			}
		},
		backToList() {
			if (this.orderId) {
				this.orderId = ''
				this.orderDetail = {}
			} else {
				this.filters.user_id = ''
				this.detail = {}
			}
		},
		doPrint() {
			window.print()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
